import React from 'react';
import styles from './Toggle.pcss';

interface ToggleProps {
    checked: boolean;
    className: string;
    id?: string;
    size: number;
    onChange?: () => void;
}

const Toggle = ({checked, className, id, size = 19, onChange}: ToggleProps) => (
    <label className={className} htmlFor={id}>
        <input
            className={styles.input}
            checked={checked}
            onChange={onChange}
            readOnly={!onChange}
            type="checkbox"
            id={id}
        />
        <div
            className={styles.slider}
            style={{borderRadius: size / 2, width: (size - 2) * 2, height: size}}>
            <span className={styles.indicator} style={{width: size, height: size}} />
        </div>
    </label>
);

export default Toggle;
